<div class="back-to-home" (click)="router.navigate([''])">
  <fa-icon [icon]="faToHome"></fa-icon> Back
</div>
<div class="w-100 h-100">
    <img src="../../../assets/branding/HRN_Page_Not_Found.png" alt="Harmony Relocation Network" class="page-not-found-image" style="width: 20em;  object-fit: fill ">
</div>
